import { z } from 'zod'

export enum Input {
  Services = 'services',
  Date = 'date',
  Slot = 'slot',
  Duration = 'duration',
  Price = 'price',
  Groomer = 'groomer',
  AppointmentId = 'appointment_id',
  StartAt = 'start_at',
  FinishAt = 'finish_at',
}

export type RescheduleAppointmentSchema = z.infer<typeof rescheduleAppointmentSchema>

export const rescheduleAppointmentSchema = z.object({
  [Input.Services]: z.object({
    id: z.number(),
    value: z.string(),
  }).array().nullable().refine((val) => val && val.length > 0, {
    message: 'Please select at least one service.',
  }),
  [Input.Date]: z.string(),
  [Input.Duration]: z.number().optional(),
  [Input.Price]: z.number().optional(),
  [Input.AppointmentId]: z.number(),
  [Input.StartAt]: z.string(),
  [Input.FinishAt]: z.string(),
  [Input.Groomer]: z.object({
    id: z.number().or(z.string()),
    first_name: z.string(),
    last_name: z.string(),
  }),
  [Input.Slot]: z.object({
    id: z.number(),
    start_at: z.string(),
    finish_at: z.string(),
    groomer: z.object({
      id: z.number().or(z.string()),
      first_name: z.string(),
      last_name: z.string(),
    }),
  }, { message: 'Please select an available slot' }),
})
